import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexLayoutModule, FlexModule } from "@angular/flex-layout";
import { MatDividerModule } from "@angular/material/divider";
import { MatIconModule } from "@angular/material/icon";
import { MatListModule } from "@angular/material/list";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";
import { AvatarModule } from "ngx-avatar";
import { LeaderboardListComponent } from "./leaderboard-list.component";

@NgModule({
    declarations: [LeaderboardListComponent],
    exports: [LeaderboardListComponent],
    imports: [
        CommonModule,
        MatIconModule,
        MatListModule,
        FlexModule,
        FlexLayoutModule,
        MatDividerModule,
        AvatarModule,
        TranslateModule,
        MatTooltipModule
    ]
})
export class LeaderboardListModule {}
